import { createDynamicThunk } from ".";

export const getNotificationListThunk = createDynamicThunk({
  typePrefix: "notifications/getNotificationListThunk",
  useHandleSearch: true,
});

export const addNotificationThunk = createDynamicThunk({
  typePrefix: "notifications/addNotificationThunk",
  endpoint: "/notifications",
  method: "POST",
  refreshList: true,
  listThunk: getNotificationListThunk,
});

export const updateNotificationThunk = createDynamicThunk({
  typePrefix: "notifications/updateNotificationThunk",
  endpoint: "/notifications",
  method: "PUT",
  refreshList: false,
  listThunk: getNotificationListThunk,
});

export const deleteNotificationThunk = createDynamicThunk({
  typePrefix: "/deleteNotificationThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getNotificationListThunk,
});

export const readAllNotificationsThunk = createDynamicThunk({
  typePrefix: "notifications/readAllNotificationsThunk",
  endpoint: "/notifications/readAll",
  method: "POST",
  refreshList: true,
  listThunk: getNotificationListThunk,
});

export const readSingleNotificationThunk = createDynamicThunk({
  typePrefix: "notifications/readSingleNotificationThunk",
  endpoint: "/notifications",
  method: "GET",
  refreshList: false,
});
